import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/notifications/components/header.tsx
var Header = ({ title }) => {
	return /* @__PURE__ */ jsx("div", {
		className: "flex justify-center items-center p-mili",
		children: /* @__PURE__ */ jsx("p", {
			className: "text-h5 font-bold text-primary-medium",
			children: title
		})
	});
};
//#endregion
export { Header };
